import { render, staticRenderFns } from "./GDPR.vue?vue&type=template&id=6792caf4&scoped=true&"
import script from "./GDPR.vue?vue&type=script&lang=js&"
export * from "./GDPR.vue?vue&type=script&lang=js&"
import style0 from "./GDPR.vue?vue&type=style&index=0&id=6792caf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6792caf4",
  null
  
)

export default component.exports